import { Input } from 'antd'
import React from 'react'

function HRInput({ placeholder='  ',...restProps}) {
  return (
    <div className="border-b border-gray-200">
      <Input
        size={"large"}
        className="
          peer 
          rounded-none
          h-full 
          w-full 
          border-none
          bg-transparent 
          px-0
          py-2.5
          font-sans 
          text-base 
          font-normal
          text-black-text 
          outline 
          outline-0 
          transition-all 
          placeholder-shown:border-grey-200 
          focus:shadow-none
          focus:outline-0 
          disabled:border-0 
          disabled:bg-transparent
          disabled:hover:bg-transparent
          disabled:cursor-default
          disabled:text-black-text
          "
        placeholder=" "
        {...restProps}
      />
      <label 
            className="
                after:content[' '] 
                pointer-events-none 
                absolute 
                left-0 
                -top-1.5 
                h-full 
                w-full
                select-none 
                text-sm
                font-normal 
                leading-tight 
                text-grey-100 
                transition-all 
                after:absolute 
                after:-bottom-1.5 
                after:block 
                after:w-full 
                after:scale-x-0 
                after:border-gray-200 
                after:transition-transform 
                after:duration-300 
                peer-placeholder-shown:text-sm 
                peer-placeholder-shown:leading-[4.25] 
                peer-placeholder-shown:overflow-hidden 
                peer-placeholder-shown:text-grey-100 
                peer-focus:text-[14px] 
                peer-focus:leading-tight 
                peer-focus:text-grey-100  
                peer-focus:after:scale-x-100 
                peer-disabled:text-transparent 
                peer-disabled:peer-placeholder-shown:text-grey-100
            "
        >{placeholder}
        </label>
    </div>
  )
}
HRInput.Group = Input.Group;
HRInput.Password = Input.Password;   
HRInput.Search = Input.Search;   
HRInput.TextArea = Input.TextArea;

export default HRInput